import { TenderSubmissionChecklistStateTypes, TenderSubmissionChecklistActionTypes } from "./TenderSubmissionChecklist.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: TenderSubmissionChecklistStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const TenderSubmissionChecklistReducer = (
  state: TenderSubmissionChecklistStateTypes = INITIAL_STATE,
  action: any
): TenderSubmissionChecklistStateTypes => {
  switch (action.type) {
    case TenderSubmissionChecklistActionTypes.FETCH_ALL_TENDER_SUBMISSION_CHECKLIST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case TenderSubmissionChecklistActionTypes.FETCH_ALL_TENDER_SUBMISSION_CHECKLIST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case TenderSubmissionChecklistActionTypes.FETCH_ALL_TENDER_SUBMISSION_CHECKLIST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TenderSubmissionChecklistActionTypes.FETCH_ALL_TENDER_SUBMISSION_CHECKLIST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case TenderSubmissionChecklistActionTypes.FETCH_ONE_TENDER_SUBMISSION_CHECKLIST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case TenderSubmissionChecklistActionTypes.FETCH_ONE_TENDER_SUBMISSION_CHECKLIST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case TenderSubmissionChecklistActionTypes.FETCH_ONE_TENDER_SUBMISSION_CHECKLIST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TenderSubmissionChecklistActionTypes.FETCH_ONE_TENDER_SUBMISSION_CHECKLIST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default TenderSubmissionChecklistReducer;
